import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { ResearchTopic } from "../../context/AnalyticsContext";
import { FC } from "react";

interface TopicsPieChartProps {
  topics: ResearchTopic[];
}

const COLORS = [
  "#0B132B", "#1D244F", "#3C5B81", "#537895", "#5BC0BE",
  "#9AD4D6", "#A6B1E1", "#13315C", "#2980B9", "#3e517a",
];

interface CustomTooltipProps {
  active?: boolean;
  payload?: Array<{
    payload: ResearchTopic;
  }>;
}

const CustomTooltip: FC<CustomTooltipProps> = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const topic = payload[0].payload;

  return (
    <div className="bg-white p-3 shadow-lg border rounded-md text-sm">
      <p className="font-semibold text-[#1d244f]">{topic.display_name}</p>
      <p className="text-gray-600">Count: {topic.count}</p>
    </div>
  );
};

const TopicsPieChart: FC<TopicsPieChartProps> = ({ topics }) => {
  return (
    <div className="w-full h-[400px] sm:h-[500px] max-w-5xl mx-auto">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart className="pb-10">
          <Pie
            data={topics}
            dataKey="count"
            nameKey="display_name"
            cx="50%"
            cy="50%"
            outerRadius="80%"
          >
            {topics.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} />
          <Legend
            verticalAlign="bottom"
            height={80}
            iconType="circle"
            wrapperStyle={{
              fontSize: '0.8rem',
              paddingTop: '5px',
            }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TopicsPieChart;
